import { render, staticRenderFns } from "./Commonheader2.vue?vue&type=template&id=6eec5b74"
import script from "./Commonheader2.vue?vue&type=script&lang=js"
export * from "./Commonheader2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports